<template>
  <transition name=modal>
    <div class="modal-mask">
      <div class="modal-wrapper" v-on:click="closeModal">
        <div class="modal-container">
          <svg v-show="modalBlocker" id="modal-close" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M 0,0 L 20,20 M 0,20 L 20,0" stroke-width=4/></path>
          </svg>
          <div class="modal-body" v-html="modalContent"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "modal",
    methods: {
      closeModal: function () {
        if (this.modalBlocker) {
          this.$store.commit('hideModal');
        }
      }
    },
    computed:{
      modalBlocker(){
        return this.$store.state.modalBlocker;
      },
      modalContent(){
        return this.$store.state.modalContent;
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    cursor: pointer
  }

  .modal-container {
    margin: 0 auto;
    padding: 20px 7px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    max-height: 80%;
    width: 300px;
    position: relative;
    border: 3px solid rgb(52, 154, 121);
  }

  .modal-header h3 {
    margin-top: 0
  }

  .modal-body {
    margin: 20px 0;
    max-height: 300px;
    overflow-y: auto;
    word-wrap: break-word
  }



  .modal-enter {
    opacity: 0
  }
  .modal-enter-to {
    opacity: 1
  }
  .modal-leave {
    opacity: 1
  }
  .modal-leave-to {
    opacity: 0
  }

  .modal-enter .modal-container, .modal-leave-active .modal-container {

  }

  #modal-close {
    position: absolute;
    top: -30px;
    right: 0;
    width: 20px;
    height: 20px;
    stroke: #fff;
    stroke-width: 4px;
    pointer-events: none
  }
</style>
